var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.68 21.48-5.21-3.9a3.903 3.903 0 0 1-1.55-3.1V1.76h18.16v12.72c0 1.21-.58 2.37-1.55 3.1l-5.21 3.9c-.68.51-1.5.77-2.32.77-.82 0-1.64-.26-2.32-.77zm-5.26-7.01c0 .74.36 1.45.95 1.9l5.21 3.9c.84.63 2.01.63 2.85 0l5.21-3.9c.59-.45.95-1.16.95-1.9V3.25H4.42v11.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 3.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h20c.41 0 .75.34.75.75s-.34.75-.75.75H2zM8 8.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75H8zM8 13.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75H8z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBill);
export default __webpack_public_path__ + "static/media/vuesax-outline-bill.4385993f966b34f7329bcf77b8d15fc6.svg";
export { ForwardRef as ReactComponent };